var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { useKeyPress } from "../../../../../../hooks/useKeyPress/";
import { FormProvider, useWatch } from "react-hook-form";
import { HookTextField } from "../../../../../Molecules";
import { useEffect } from "react";
var LinkEditorForm = function (_a) {
    var methods = _a.methods, onSubmit = _a.onSubmit;
    var text = useWatch({
        control: methods.control,
        name: "text",
    });
    var enterPressed = useKeyPress("Enter");
    useEffect(function () {
        if (enterPressed) {
            onSubmit();
        }
    }, [enterPressed]);
    // requires either text or a link cannot have neither
    return (_jsx(FormProvider, __assign({}, methods, { children: _jsx("form", __assign({ id: "wysiwyg-link-form", onSubmit: onSubmit, "data-testid": "wysiwyg-link-form" }, { children: _jsxs(Stack, __assign({ gap: 3 }, { children: [_jsx(HookTextField, { id: "dialog-text", outerLabel: "Text", placeholder: "Display text", type: "text", name: "text", sx: { width: "100%" } }), _jsx(HookTextField, { id: "dialog-link", outerLabel: "Link", placeholder: "https://...", type: "text", name: "link", validationArr: ["urlOrEmpty"], rules: {
                            validate: {
                                requireTextOrUrl: function (url) {
                                    if (!url && !text) {
                                        return "Must provide text or link.";
                                    }
                                    return true;
                                },
                            },
                        }, sx: { width: "100%" } })] })) })) })));
};
export default LinkEditorForm;
